import React from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaCalendarAlt } from "react-icons/fa";

const customStyles = {
  control: (provided) => ({
    ...provided,
    backgroundColor: "#000",
    borderColor: "#292524",
    color: "white",
    padding: "0.1rem 0.25rem",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "white",
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: "#111",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? "#1f2937" : "#111",
    color: "white",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "white",
  }),
  input: (provided) => ({
    ...provided,
    color: "white",
  }),
};

const Modal = ({
  isOpen,
  onClose,
  data,
  title,
  type,
  onChange,
  onSave,
  typeOptions,
  mode = "edit", // 'edit' or 'create'
}) => {
  if (!isOpen) return null;

  console.log("Modal data:", data);

  const isEdit = mode === "edit";


  return (
    <div className="fixed inset-0 z-[99999] bg-black bg-opacity-50 px-3 flex items-center justify-center">
      <div className="bg-[#121212] text-white rounded-lg p-4 md:p-6 w-full max-w-lg relative">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-400 hover:text-white text-xl"
        >
          &times;
        </button>
        <h2 className="text-xl font-semibold mb-6">
          {title}
        </h2>

        {/* Location Name */}
        <div className="mb-4">
          <label className="block text-sm font-medium mb-2">{type !== 'Bankroll' ? 'Location Name' : 'Date'}</label>
          {type === "Bankroll" ? (
            <div className="relative">
              <FaCalendarAlt className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 z-[1]" />
              <DatePicker
                selected={data.transactionDate ? new Date(data.transactionDate) : new Date()}
                onChange={(date) =>
                  onChange({ target: { name: "transactionDate", value: date } })
                }
                dateFormat="do MMMM yyyy"
                className="w-full pl-10 pr-3 py-2 border border-border rounded bg-black text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholderText="Select date"
                calendarClassName="custom-datepicker"
              />
            </div>
          ) : (
            <input
              type="text"
              name="name"
              value={data.name}
              onChange={onChange}
              className="w-full px-3 py-2 border border-border rounded bg-black text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          )}
        </div>


        {/* Type */}
        <div className="mb-4">
          <label className="block text-sm font-medium mb-2">Type</label>
          <Select
            options={typeOptions}
            styles={customStyles}
            value={typeOptions.find((opt) => opt.value === data.type)}
            onChange={(selectedOption) =>
              onChange({ target: { name: "type", value: selectedOption.value } })
            }
          />
        </div>

        {/* Address */}
        <div className="mb-4">
          <label className="block text-sm font-medium mb-2">{type === 'Bankroll' ? 'Amount' : 'Address'}</label>
          <input
            type={type === 'Bankroll' ? 'number' : 'text'}
            name={type === 'Bankroll' ? 'amount' : 'address'}
            value={type === 'Bankroll' ? data.amount : data.address}
            onChange={onChange}
            className="w-full px-3 py-2 border border-border rounded bg-black text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
          />

        </div>

        {/* Description */}

        {type === 'Bankroll' && (
          <div className="mb-4">
            <label className="block text-sm font-medium mb-2">Description</label>
            <textarea
              name="description"
              value={data.description}
              onChange={onChange}
              rows="3"
              className="w-full px-3 py-2 border border-border rounded bg-black text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        )

        }
        {/* Sessions */}
        {isEdit && type !== 'Bankroll' && (
          <>
            <div className="mb-1">
              <label className="block text-sm font-medium mb-2">Sessions</label>
              <input
                type="text"
                value={data.sessions}
                readOnly
                className="w-full px-3 py-2 border border-border rounded bg-black text-white opacity-60 cursor-not-allowed"
              />
            </div>
            <p className="text-xs text-gray-400 mb-6">
              Sessions count is automatically calculated based on game data.
            </p>
          </>
        )}

        {/* Buttons */}
        <div className="flex justify-end gap-4 mt-3">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-gray-600 rounded hover:bg-border"
          >
            Cancel
          </button>
          <button
            onClick={onSave}
            className="bg-secondary  hover:opacity-75 px-4 py-2 rounded text-white flex items-center gap-2 "
          >
            {isEdit ? "Save Changes" : "Create"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
